import { render } from "./TableComponent.vue?vue&type=template&id=0a92f558&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=0a92f558&lang=scss&scoped=true"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a92f558"]])

export default __exports__